import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MaterialTable from 'material-table';
import { UserType } from '../validation';
import i18n from '../i18n';
import { tableIcons } from './shared/icons';
import { modelPositions } from '../constants/employeePositions';

import ImagePopoverAvatar from './ImagePopoverAvatar';

class EmployeeSearchTable extends Component {

  filterEmployees = (user, employees) => {
    let filteredEmployees = [];
    if (user.scopes.includes('employees:read')) {
      filteredEmployees = employees;
    }
    else if (user.scopes.includes('studio-models:read')) {
      filteredEmployees = employees.filter(employee => (
        (employee.positions.find(pos => modelPositions.includes(pos)))
        || (employee && employee.email === user.email)
      ))
    }
    return filteredEmployees;
  }

  render() {
    const { employees, onRowClick, user } = this.props;

    return (
      <MaterialTable
        title={i18n.t('studioEmployeeSearch')}
        columns={[
          // TODO: theming overrides for sort arrow animation, sorting entirely disabled until fixed.
          {
            title: i18n.t('profileImage'),
            field: 'profileImage',
            sorting: false,
            disableClick: true,
            render: rowData => <ImagePopoverAvatar src={rowData.profileImage} />
          },
          { title: i18n.t('name'), field: 'name', sorting: false },
          { title: i18n.t('emailAddress'), field: 'email', sorting: false },
          { title: i18n.t('origins'), field: 'origins', sorting: false },
          {
            title: i18n.t('nationalities'),
            field: 'nationalities',
            sorting: false
          },
          {
            title: i18n.t('primaryPhoneNumber'),
            field: 'phoneNumber',
            sorting: false
          },
          {
            title: i18n.t('primaryPosition'),
            field: 'primaryPosition',
            sorting: false
          },
          {
            title: i18n.t('booking:abilityTier'),
            field: 'abilityTier',
            sorting: false
          },
          {
            title: i18n.t('employeeType'),
            field: 'employeeTypeDisplay',
            sorting: false
          }
        ]}
        data={this.filterEmployees(user, employees)}
        icons={tableIcons}
        onRowClick={onRowClick}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 25, 50]
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

EmployeeSearchTable.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowClick: PropTypes.func.isRequired,
  user: UserType.isRequired
};
 
export { EmployeeSearchTable as EmployeeSearchTableNoConnect };
export default connect(mapStateToProps)(EmployeeSearchTable);
